import styles from './post-body.module.css'
import ParserView from '@/components/ParserView'

type TPostBodyProps = {
  content: string | null | undefined
}

export default function PostBody({ content }: TPostBodyProps) {
  if (content) {
    const contentInJson = JSON.parse(content)
    return (
      <div className="post-detail">
        <div className={styles.content}>
          <ParserView json={contentInJson.json} />
        </div>
      </div>
    )
  }

  return <div />
}
